export enum SignatureRequestErrorEnum {
    EsignaturesTrialAccountForbidden = '701',
    SignatureRequestCanceled = '702'
}
